
module.exports = {
  brand: function(d) { return "THE OUTNET"; },
  contact: {
    title: function(d) { return "Benötigen Sie Hilfe?"; },
    copyBeforeLink: function(d) { return "Wenden Sie sich bei Fragen bitte an unseren THE OUTNET"; },
    copyAfterLink: function(d) { return "."; },
    href: function(d) { return "/page/help/returns/"; },
    customerCare: function(d) { return "Kundenservice"; }
  },
  search: {
    text: function(d) { return "THE OUTNET durchsuchen"; },
    clear: function(d) { return "Löschen"; },
    categories: function(d) { return "Kategorien"; },
    designers: function(d) { return "Designer"; },
    products: function(d) { return "Artikel"; },
    colours: function(d) { return "Farben"; },
    cta: function(d) { return "Suche"; },
    noResult: function(d) { return "Wir haben keine Ergebnisse gefunden für " + d.searchTerm; },
    tryAgain: function(d) { return "Bitte versuchen Sie es erneut."; },
    loading: function(d) { return "Suche"; },
    viewAll: function(d) { return "Alle Ergebnisse anzeigen"; }
  },
  price: {
    discountPercentage: function(d) { return "(-" + d.discountPercentage + "%)"; },
    discountPrice: function(d) { return "Preis mit Reduzierung"; },
    currencyExchange: function(d) { return "(Ca. " + d.exchangeCurrency + " " + d.exchangePrice + ")"; },
    wasPriceOriginal: function(d) { return "UPE: " + d.wasPrice; },
    wasPrice: function(d) { return "UPE:"; },
    originalPrice: function(d) { return "Ursprünglicher Preis:"; },
    minimumPrice: function(d) { return "Niedrigster Preis in 30 Tagen"; },
    minimumPriceEqual: function(d) { return "Dies ist der niedrigste Preis in 30 Tagen"; },
    priceInformation: {
      title: function(d) { return "Informationen zur Preisgestaltung"; },
      subtitle: function(d) { return "Die Preisgestaltung bei THE OUTNET:"; },
      descriptionRRP: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Niedrigster Preis in 30 Tagen:**\nDer niedrigste Preis, zu dem der Artikel in den letzten 30 Tagen angeboten wurde\n\n**3. Unverbindliche Preisempfehlung (UPE):**\nDer Preis, den der Hersteller als Verkaufspreis an die Kundschaft empfiehlt\n\n[Mehr erfahren](" + d.link + ")"; },
      descriptionOriginalPrice: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Niedrigster Preis in 30 Tagen:**\nDer niedrigste Preis, zu dem der Artikel in den letzten 30 Tagen angeboten wurde\n\n**3. Ursprünglicher Preis:**\nDer Preis, zu dem der Artikel zum ersten Mal in der THE OUTNET-App und -Website gelistet wurde\n\n[Mehr erfahren](" + d.link + ")"; },
      descriptionRRPWithoutMinimumMessage: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Unverbindliche Preisempfehlung (UPE):**\nDer Preis, den der Hersteller als Verkaufspreis an die Kundschaft empfiehlt\n\n[Mehr erfahren](" + d.link + ")"; },
      descriptionOriginalPriceWithoutMinimumMessage: function(d) { return "**1. Aktueller Preis:**\nDer Preis, zu dem der Artikel exklusiv in der THE OUTNET-App und auf der Website angeboten wird\n\n**2. Ursprünglicher Preis:**\nDer Preis, zu dem der Artikel zum ersten Mal in der THE OUTNET-App und -Website gelistet wurde\n\n[Mehr erfahren](" + d.link + ")"; }
    }
  },
  localeSwitch: {
    languages: {
      en: function(d) { return "English"; },
      ar: function(d) { return "اللغة العربية"; },
      de: function(d) { return "Deutsch"; },
      fr: function(d) { return "française"; },
      ja: function(d) { return "日本語"; },
      ko: function(d) { return "한국어"; }
    },
    changeCountry: {
      title: function(d) { return "Standort wechseln"; },
      description: function(d) { return "Bitte wählen Sie Ihren Standort aus der folgenden Liste, um THE OUTNET optimal nutzen zu können"; }
    },
    itemsUnavailable: {
      title: function(d) { return "Artikel nicht verfügbar"; },
      description: function(d) { return "Leider ist ein oder mehrere Artikel aus Ihrem Warenkorb in diesem Land nicht verfügbar. Leider werden diese Artikel aus Ihrem Warenkorb gelöscht, wenn Sie das Land ändern."; },
      confirmation: function(d) { return "Länderwechsel bestätigen"; },
      addToWishlist: function(d) { return "Artikel in der Wunschliste speichern"; }
    }
  },
  cookieBanner: {
    title: function(d) { return "Cookies und Datenschutz"; },
    message: function(d) { return "Indem Sie unsere Website weiterhin nutzen, erklären Sie sich mit der Verwendung von Cookies einverstanden, durch die das Funktionieren der Website gewährleistet wird, angezeigte Inhalte personalisiert, statistische und analytische Untersuchungen durchgeführt sowie die von uns angebotenen Produkte und Dienstleistungen verbessert werden können. In Ihren Browsereinstellungen können Sie Cookies blockieren oder löschen. Weitere Informationen zur Verwendung von Cookies finden Sie im Abschnitt"; },
    cta: function(d) { return "\"Cookie-Richtlinien\"."; },
    href: function(d) { return "/page/help/cookie-policy"; }
  },
  nav: {
    myAccount: {
      text: function(d) { return "Hallo, " + d.name; },
      href: function(d) { return "/account"; }
    },
    myAccountMobile: {
      text: function(d) { return "Konto"; }
    },
    signIn: {
      text: function(d) { return "Anmelden"; },
      href: function(d) { return "/account/login"; }
    },
    signOut: {
      text: function(d) { return "Abmelden"; },
      href: function(d) { return "/account/login"; }
    },
    account: {
      text: function(d) { return "Konto"; },
      href: function(d) { return "/account"; }
    },
    wishlist: {
      text: function(d) { return "Wunschliste"; },
      href: function(d) { return "/account/wishlist"; }
    },
    checkout: {
      text: function(d) { return "Bestellung"; },
      href: function(d) { return "/checkout"; }
    },
    register: {
      text: function(d) { return "Registrieren"; },
      href: function(d) { return "/account/login"; }
    },
    track: {
      text: function(d) { return "Bestellung nachverfolgen"; },
      href: function(d) { return "/account/searchorder"; }
    },
    create: {
      text: function(d) { return "Rücksendung erstellen"; },
      href: function(d) { return "/pex/searchorder"; }
    },
    "return": {
      text: function(d) { return "Rücksendung verfolgen"; },
      href: function(d) { return "/account/myreturn"; }
    },
    orders: {
      text: function(d) { return "Bestellungen"; },
      href: function(d) { return "/account/orders"; }
    }
  },
  courtesyNav: {
    customerServiceInfo: {
      text: function(d) { return "Kundenservice"; },
      href: function(d) { return "/page/help/contact-us"; }
    },
    deliveryInfo: {
      text: function(d) { return "Lieferung"; },
      href: function(d) { return "/page/help/customer-service/delivery"; }
    },
    returnsInfo: {
      text: function(d) { return "Rückgaben"; },
      href: function(d) { return "/page/help/customer-service/returns"; }
    },
    myOrders: {
      text: function(d) { return "Ihre Bestellungen"; },
      href: function(d) { return "/account/orders"; }
    },
    trackOrder: {
      text: function(d) { return "Bestellung nachverfolgen"; },
      href: function(d) { return "/account/track-order"; }
    },
    createReturn: {
      text: function(d) { return "Rücksendung in Auftrag geben"; },
      href: function(d) { return "/account/create-return"; }
    }
  },
  copyright: {
    yearFrom: function(d) { return "2009 - "; },
    copy: function(d) { return ", Teil der YOOX NET-A-PORTER GROUP."; },
    extraCopy: function(d) { return "Die Personen, die auf unserer Webseite vorgestellt werden, sind nicht mit THE OUTNET oder den gezeigten Produkten verbunden und unterstützen diese nicht."; }
  },
  social: {
    title: function(d) { return "Stay Social"; }
  },
  externalLinks: {
    mrp: function(d) { return "https://www.mrporter.com/"; },
    nap: function(d) { return "https://www.net-a-porter.com/"; }
  },
  error: {
    megaNav: function(d) { return "Ups, leider wurde das Menü nicht gefunden"; }
  },
  checkout: {
    copy: function(d) { return "Sicher bestellen"; }
  },
  footer: {
    footerLinks: function(d) { return "Hilfe & Informationen"; },
    contactAndLocale: function(d) { return "Durchgehender Kundenservice"; },
    signupAndSocial: function(d) { return "Stay Social"; }
  },
  fastUserRegistration: {
    heading: function(d) { return "Genießen Sie −10% auf Ihre nächste Bestellung bei THE OUTNET"; },
    description: function(d) { return "Abonnieren Sie die Newsletter von THE OUTNET und anderen Brands von LuxExperience B.V., um −10% Reduzierung auf Ihre nächste Bestellung bei THE OUTNET zu genießen. [Einige Artikel sind ausgenommen – siehe AGB](https://www.theoutnet.com/page/policies/general-terms-and-conditions-of-sale/#promotional-codes)."; },
    subscribe: function(d) { return "Abonnieren"; },
    placeholder: function(d) { return "Geben Sie Ihre E-Mail-Adresse ein"; },
    sucessfulEmailMessage: function(d) { return "Vielen Dank, Sie haben unsere E-Mails nun abonniert!"; },
    NoEmailMessage: function(d) { return "Geben Sie Ihre E-Mail-Adresse ein"; },
    invalidEmailMessage: function(d) { return "Ungültige E-Mail-Adresse"; }
  },
  registrationForm: {
    emailReadMore: function(d) { return "Was erhalte ich?"; },
    emailInfo: function(d) { return "Wenn Sie das Kästchen ankreuzen, melden Sie sich bei THE OUTNET und anderen Brands von LuxExperience B.V.* an, um per E-Mail über neu eingetroffene Artikel, außergewöhnliche Preisnachlässe, Style-Tipps von Experten und unsere neuesten (und besten) Angebote informiert zu werden.\n\nSie können sich jederzeit abmelden, indem Sie Ihre Einstellungen in Ihrem Konto verwalten oder die Anweisungen in den einzelnen E-Mails befolgen.\n\nZu LuxExperience B.V. gehören folgende Brands:  MR PORTER, MYTHERESA, NET-A-PORTER, THE OUTNET und YOOX.\n\nWenn Sie unsere Websites bzw. Apps, einschließlich der darin angebotenen Dienste, besuchen und nutzen, unterliegen Ihre Daten den jeweiligen Datenschutzrichtlinien der einzelnen Brands: [MR PORTER](https://www.mrporter.com/content/help/privacy-policy/), [MYTHERESA](https://www.mytheresa.com/to/service/privacy-policy), [NET-A-PORTER](https://www.net-a-porter.com/content/help/privacy-policy/), [THE OUTNET](https://www.theoutnet.com/page/policies/privacy-policy/) und [YOOX](https://www.yoox.com/Legal/Privacypolicy)."; },
    emailTitle: function(d) { return "Unsere Emails"; }
  },
  seoMeta: {
    title: function(d) { return "Reduzierung Designer Fashion | Sale bis zu -70% bei THE OUTNET"; },
    description: function(d) { return "Mit über 350 Luxus-Designerbrands zu einmaligen Preisen ist Shopping auf höchstem Style-Niveau bei THE OUTNET garantiert!"; }
  },
  webpush: {
    title: function(d) { return "Möchten Sie vor allen anderen von unseren neuesten Angeboten und Ermäßigungen erfahren?"; },
    description: function(d) { return "Wir schicken Ihnen eine Benachrichtigung, damit Sie nichts verpassen!"; },
    toggleMessage: function(d) { return "Web-Push aktivieren"; }
  },
  multishop: {
    mens: function(d) { return "Herren"; },
    womens: function(d) { return "Damen"; }
  },
  promptBasketItem: {
    title: function(d) { return "Dieser Artikel wurde jetzt in Ihren Warenkorb gelegt"; },
    button: function(d) { return "Warenkorb ansehen"; }
  }
}